import { ActionList, Button, Popover } from '@shopify/polaris'
import React, { useState } from 'react'
import {
    MenuVerticalIcon
} from '@shopify/polaris-icons';

const ShippingCardActions = ({ actionList }) => {
    const [actionActive, toggleAction] = useState(false);

    const handleToggleAction = event => {
        if (event) event.stopPropagation()
        toggleAction(!actionActive);
    };
    return (
        <Popover
            active={actionActive}
            activator={<Button icon={MenuVerticalIcon} variant="plain" onClick={handleToggleAction} />}
            onClose={() => handleToggleAction()}
        >
            <ActionList items={actionList} />
        </Popover>
    )
}

export default ShippingCardActions